import { HttpInterceptorFn } from '@angular/common/http';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../services';
import { inject } from '@angular/core';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  return from(authService.getTokenAsync()).pipe(
    switchMap((token) => {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`).set('Content-Type', 'application/json')
      });
      return next(authReq);
    })
  );
};
